import React, { Suspense, lazy } from 'react'
import Active_230 from '@/views/activity_230'
import Active_230_Raffle from '@/views/activity_230/raffle'
import Active_230_Award from '@/views/activity_230/award'
import Active_230_Rule from '@/views/activity_230/rule'
const LoadingFallback = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '16px',
      color: '#666'
    }}>
      加载中...
    </div>
)

const lazyLoad = (importFunc) => {
  const LazyComponent = lazy(importFunc)
  return (props) => (
      <Suspense fallback={<LoadingFallback />}>
        <LazyComponent {...props} />
      </Suspense>
  )
}

const routes = [
  {
    path: '*',
    component: lazyLoad(() => import('@/views/error-page/404')),
    exact: true
  }
]

const asyncRoutes = [
  {
    path: '/activity/activitys',
    component: lazyLoad(() => import('@/views/activitys')),
    name: 'Activitys'
  },
  {
    path: '/activity/address',
    component: lazyLoad(() => import('@/views/address')),
    name: 'Address'
  },
  {
    path: '/activity/my-invitation/:id',
    component: lazyLoad(() => import('@/views/user-new/my-invitation')),
    name: 'MyInvitationWithId'
  },
  {
    path: '/activity/my-invitation',
    component: lazyLoad(() => import('@/views/user-new/my-invitation')),
    name: 'MyInvitation'
  },
  {
    path: '/activity/share-pull-regist/:code',
    component: lazyLoad(() => import('@/views/user-new/share-pull-regist')),
    name: 'SharePullRegist'
  },
  {
    path: '/activity/regist/:type/:code',
    component: lazyLoad(() => import('@/views/user-new/regist')),
    name: 'RegistWithType'
  },
  {
    path: '/activity/regist/:code',
    component: lazyLoad(() => import('@/views/user-new/regist')),
    name: 'Regist'
  },
  {
    path: '/activity/sku-exchange',
    component: lazyLoad(() => import('../views/sku-exchange/index')),
    name: 'sku-exchange'
  },
  {
    path: '/activity/active_20',
    component: lazyLoad(() => import('@/views/activity_42')),
    name: 'active_20'
  },
  {
    path: '/activity/active_20/share-pull-regist/:code',
    component: lazyLoad(() => import('@/views/integral_0803_20/share-pull-regist/index')),
    name: 'active_20_share'
  },
  {
    path: '/activity/active_31',
    component: lazyLoad(() => import('@/views/activity_31')),
    name: 'active_31',
    exact: true
  },
  {
    path: '/activity/active_31/explain',
    component: lazyLoad(() => import('@/views/activity_31/explain')),
    name: 'active_31_explain',
    exact: true
  },
  {
    path: '/activity/active_41',
    component: lazyLoad(() => import('@/views/activity_41')),
    name: 'active_41'
  },
  {
    path: '/activity/active_42',
    component: lazyLoad(() => import('@/views/activity_42')),
    name: 'active_42',
    exact: true
  },
  {
    path: '/activity/active_42/outsite/:inviteCode',
    component: lazyLoad(() => import('@/views/activity_42/outsite')),
    name: 'active_42_outsite',
    exact: true
  },
  {
    path: '/activity/active_42/my',
    component: lazyLoad(() => import('@/views/activity_42/my-invite')),
    name: 'active_42_my',
    exact: true
  },
  {
    path: '/activity/active_42/withdraw',
    component: lazyLoad(() => import('@/views/activity_42/withdraw')),
    name: 'active_42_withdraw',
    exact: true
  },
  {
    path: '/activity/active_50',
    component: lazyLoad(() => import('@/views/activity_50')),
    name: 'active_50'
  },
  {
    path: '/activity/active_50/share-pull-regist/:code',
    component: lazyLoad(() => import('@/views/activity_50/share-pull-regist/index')),
    name: 'active_50_share'
  },
  {
    path: '/activity/active_100',
    component: lazyLoad(() => import('@/views/activity_100')),
    name: 'active_100'
  },
  {
    path: '/activity/active_100/share-pull-regist/:code',
    component: lazyLoad(() => import('@/views/activity_100/share-pull-regist/index')),
    name: 'active_100_share'
  },
  {
    path: '/activity/active_110',
    component: lazyLoad(() => import('@/views/activity_110')),
    name: 'active_110'
  },
  {
    path: '/activity/active_120',
    component: lazyLoad(() => import('@/views/activity_120')),
    name: 'active_120'
  },
  {
    path: '/activity/active_121',
    component: lazyLoad(() => import('@/views/activity_121')),
    name: 'active_121'
  },
  {
    path: '/activity/active_130',
    component: lazyLoad(() => import('@/views/activity_130')),
    name: 'active_130'
  },
  {
    path: '/activity/active_130/create',
    component: lazyLoad(() => import('@/views/activity_130/create')),
    name: 'active_130_create'
  },
  {
    path: '/activity/active_130/content',
    component: lazyLoad(() => import('@/views/activity_130/content')),
    name: 'active_130_content'
  },
  {
    path: '/activity/active_135',
    component: lazyLoad(() => import('@/views/activity_135')),
    name: 'active_135'
  },
  {
    path: '/activity/active_135/settle',
    component: lazyLoad(() => import('@/views/activity_135/settle')),
    name: 'active_135_settle'
  },
  {
    path: '/activity/active_135/rules',
    component: lazyLoad(() => import('@/views/activity_135/rules')),
    name: 'active_135_rules'
  },
  {
    path: '/activity/active_136',
    component: lazyLoad(() => import('@/views/activity_136')),
    name: 'active_136'
  },
  {
    path: '/activity/active_136/settle',
    component: lazyLoad(() => import('@/views/activity_136/settle')),
    name: 'active_136_settle'
  },
  {
    path: '/activity/active_136/rules',
    component: lazyLoad(() => import('@/views/activity_136/rules')),
    name: 'active_136_rules'
  },
  {
    path: '/activity/active_138',
    component: lazyLoad(() => import('@/views/activity_138')),
    name: 'active_138'
  },
  {
    path: '/activity/active_138/rules',
    component: lazyLoad(() => import('@/views/activity_138/rules')),
    name: 'active_138_rules'
  },
  {
    path: '/activity/active_139',
    component: lazyLoad(() => import('@/views/activity_139')),
    name: 'active_139'
  },
  {
    path: '/activity/active_139/rules',
    component: lazyLoad(() => import('@/views/activity_139/rules')),
    name: 'active_139_rules'
  },
  {
    path: '/activity/active_145',
    component: lazyLoad(() => import('@/views/activity_145')),
    name: 'active_145'
  },
  {
    path: '/activity/active_146',
    component: lazyLoad(() => import('@/views/activity_146')),
    name: 'active_146'
  },
  {
    path: '/activity/active_147',
    component: lazyLoad(() => import('@/views/activity_147')),
    name: 'active_147'
  },
  {
    path: '/activity/active_147/code',
    component: lazyLoad(() => import('@/views/activity_147/code')),
    name: 'active_147_code'
  },
  {
    path: '/activity/active_148',
    component: lazyLoad(() => import('@/views/activity_148')),
    name: 'active_148'
  },
  {
    path: '/activity/active_148/code',
    component: lazyLoad(() => import('@/views/activity_148/code')),
    name: 'active_148_code'
  },
  {
    path: '/activity/active_149',
    component: lazyLoad(() => import('@/views/activity_149')),
    name: 'active_149'
  },
  {
    path: '/activity/active_150',
    component: lazyLoad(() => import('@/views/activity_150')),
    name: 'active_150'
  },
  {
    path: '/activity/active_151',
    component: lazyLoad(() => import('@/views/activity_151')),
    name: 'active_151'
  },
  {
    path: '/activity/active_151/code',
    component: lazyLoad(() => import('@/views/activity_151/code')),
    name: 'active_151_code'
  },
  {
    path: '/activity/active_170',
    component: lazyLoad(() => import('@/views/activity_170')),
    name: 'active_170'
  },
  {
    path: '/activity/active_171',
    component: lazyLoad(() => import('@/views/activity_171')),
    name: 'active_171'
  },
  {
    path: '/activity/active_172',
    component: lazyLoad(() => import('@/views/activity_172')),
    name: 'active_172'
  },
  {
    path: '/activity/active_173/code',
    component: lazyLoad(() => import('@/views/activity_173/code')),
    name: 'active_173_code'
  },
  {
    path: '/activity/active_174',
    component: lazyLoad(() => import('@/views/activity_174')),
    name: 'active_174'
  },
  {
    path: '/activity/active_174/code',
    component: lazyLoad(() => import('@/views/activity_174/code')),
    name: 'active_174_code'
  },
  {
    path: '/activity/active_190',
    component: lazyLoad(() => import('@/views/activity_190')),
    name: 'active_190'
  },
  {
    path: '/activity/active_190/rules',
    component: lazyLoad(() => import('@/views/activity_190/rules')),
    name: 'active_190_rules'
  },
  {
    path: '/activity/active_205',
    component: lazyLoad(() => import('@/views/activity_205')),
    name: 'active_205'
  },
  {
    path: '/activity/active_208',
    component: lazyLoad(() => import('@/views/activity_208')),
    name: 'active_208'
  },
  {
    path: '/activity/active_209',
    component: lazyLoad(() => import('@/views/activity_209')),
    name: 'active_209'
  },
  {
    path: '/activity/active_210',
    component: lazyLoad(() => import('@/views/activity_210')),
    name: 'active_210'
  },
  {
    path: '/activity/active_210/code',
    component: lazyLoad(() => import('@/views/activity_210/share')),
    name: 'active_210_code'
  },
  {
    path: '/activity/active_230/raffle',
    component: Active_230_Raffle,
    name: 'active_230_raffle'
  },
  {
    path: '/activity/active_230/award',
    component: Active_230_Award,
    name: 'active_230_award'
  },
  {
    path: '/activity/active_230/rule', // 创作激励
    component: Active_230_Rule,
    name: 'active_230_rule'
  },
  {
    path: '/activity/active_230', // 创作激励
    component: Active_230,
    name: 'active_230'
  },
   {
    path: '/activity/active_231',
    component: lazyLoad(() => import('@/views/activity_231')),
    name: 'active_231'
  },
  {
    path: '/activity/weixin',
    component: lazyLoad(() => import('@/views/weixin')),
    name: 'Weixin',
    exact: true
  }
]

export { routes, asyncRoutes }
